
import {ComputedRef, defineComponent, watch} from "vue";
import QuestionnaireCover from "./QuestionnaireCover.vue";
import Questionnaire from "./Questionnaire.vue";
import {ContentProvider, ContentProviderType} from "../../../../domain/entities/content-provider/content-provider";
import {computed} from "@vue/reactivity";
import {ExerciseStudent, Question} from "./helpers";
import {useStore} from "vuex";
import {useRouter} from "vue-router";

export default defineComponent({
  name: "ExerciseViewer",
  components: {Questionnaire, QuestionnaireCover}
});
